var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import TextArea from '../../../uikit/inputs/TextArea';
import { noop } from '../../../utils/noop';
export var Textarea = function (props) {
    var _a = props.error, error = _a === void 0 ? false : _a, _b = props.onChange, onChange = _b === void 0 ? noop : _b, _c = props.onBlur, onBlur = _c === void 0 ? noop : _c, _d = props.onFocus, onFocus = _d === void 0 ? noop : _d, textInputProps = __rest(props, ["error", "onChange", "onBlur", "onFocus"]);
    var handleChange = useCallback(function (e) {
        onChange(e.target.value, e);
    }, [onChange]);
    var handleFocus = useCallback(function (e) {
        onFocus(e);
    }, [onFocus]);
    var handleBlur = useCallback(function (e) {
        onBlur(e.target.value, e);
    }, [onBlur]);
    return (React.createElement(TextArea, __assign({}, textInputProps, { onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, error: error })));
};
